<template>

  <div>
      <ul class="navbar-nav bg-gradient sidebar sidebar-dark accordion" id="accordionSidebar">
        <!-- Sidebar - Brand -->
        <router-link to="" class="sidebar-brand d-flex align-items-center justify-content-center">
          <div class="sidebar-brand-text mx-3">
            Softciudadano
          </div>
        </router-link>
    
        <!-- Divider -->
        <hr class="sidebar-divider my-0">
    
        <!-- Nav Item - Dashboard -->
        <li class="nav-item active">
            <router-link class="nav-link" to="/">
                <i class="fas fa-fw fa-tachometer-alt"></i>
                <span>Dashboard</span>         
            </router-link>
        </li>
    
        <!-- Divider -->
        <hr class="sidebar-divider">
    
        <!-- Heading -->
        <div class="sidebar-heading">Administrar</div>
    
        <!-- Nav Item - Pages Collapse Menu -->

        <li class="nav-item">
          <a
            class="nav-link collapsed"
            href="#"
            data-toggle="collapse"
            data-target="#collapseCases"
            aria-expanded="true"
            aria-controls="collapseCases"
          >
            <i class="fas fa-fw fa-wrench"></i>
            <span>Casos</span>
          </a>
          <div
            id="collapseCases"
            class="collapse"
            aria-labelledby="headingUtilities"
            data-parent="#accordionSidebar"
          >
            <div class="bg-white py-2 collapse-inner rounded">
              <h6 class="collapse-header">Peticiones:</h6>
              <router-link class="collapse-item" to="/cases">Casos</router-link>
              <router-link class="collapse-item" to="/admin/pending-cases">Casos pendientes</router-link>
            </div>

          </div>
        </li>

        <li class="nav-item">
          <a
            class="nav-link collapsed"
            href="#"
            data-toggle="collapse"
            data-target="#collapseTwo"
            aria-expanded="true"
            aria-controls="collapseTwo"
          >
            <i class="fas fa-fw fa-cog"></i>
            <span>Categorías</span>
          </a>
          <div
            id="collapseTwo"
            class="collapse"
            aria-labelledby="headingTwo"
            data-parent="#accordionSidebar">
            <div class="bg-white py-2 collapse-inner rounded">
              <h6 class="collapse-header">Categorías</h6>
              <router-link class="collapse-item" to="/admin/cities">Organizaciones</router-link>
              <router-link class="collapse-item" to="/admin/zones">Área</router-link>
              <router-link class="collapse-item" to="/admin/roles">Roles</router-link>
            </div>
          </div>
        </li>

        <li class="nav-item">
          <a
            class="nav-link collapsed"
            href="#"
            data-toggle="collapse"
            data-target="#collapseAgenda"
            aria-expanded="true"
            aria-controls="collapseAgenda"
          >
            <i class="fas fa-fw fa-calendar"></i>
            <span>Agenda</span>
          </a>
          <div
            id="collapseAgenda"
            class="collapse"
            aria-labelledby="headingTwo"
            data-parent="#accordionSidebar">
            <div class="bg-white py-2 collapse-inner rounded">
              <h6 class="collapse-header">Agenda</h6>
              <router-link class="collapse-item" to="/admin/schedule">Agenda</router-link>
              <router-link class="collapse-item" to="/admin/schedule-category">Categorías</router-link>
              <router-link class="collapse-item" to="/admin/schedule-subcategory">Sub-categorías</router-link>
            </div>
          </div>
        </li>
    
        <!-- Nav Item - Utilities Collapse Menu -->
        <li class="nav-item">
          <a
            class="nav-link collapsed"
            href="#"
            data-toggle="collapse"
            data-target="#collapseUtilities"
            aria-expanded="true"
            aria-controls="collapseUtilities"
          >
            <i class="fas fa-fw fa-wrench"></i>
            <span>Dependencias</span>
          </a>
          <div
            id="collapseUtilities"
            class="collapse"
            aria-labelledby="headingUtilities"
            data-parent="#accordionSidebar"
          >
            <div class="bg-white py-2 collapse-inner rounded">
              <h6 class="collapse-header">Asignación:</h6>
              <router-link class="collapse-item" to="/admin/entities">Dependencias</router-link>
              <router-link class="collapse-item" to="/admin/entities/zones">Asignación de áreas</router-link>
            </div>
          </div>
        </li>


        <li class="nav-item">
          <a
            class="nav-link collapsed"
            href="#"
            data-toggle="collapse"
            data-target="#collapseMenuApp"
            aria-expanded="true"
            aria-controls="collapseMenuApp"
          >
            <i class="fas fa-fw fa-wrench"></i>
            <span>Menú APP</span>
          </a>
          <div
            id="collapseMenuApp"
            class="collapse"
            aria-labelledby="headingUtilities"
            data-parent="#accordionSidebar"
          >
            <div class="bg-white py-2 collapse-inner rounded">
              <h6 class="collapse-header">Asignación:</h6>
              <router-link class="collapse-item" to="/admin/menu-app">Menú APP</router-link>
            </div>
          </div>
        </li>


        <li class="nav-item">
          <a
            class="nav-link collapsed"
            href="#"
            data-toggle="collapse"
            data-target="#collapseAdsApp"
            aria-expanded="true"
            aria-controls="collapseAdsApp"
          >
            <i class="fas fa-fw fa-image"></i>
            <span>Imagen publicidad</span>
          </a>
          <div
            id="collapseAdsApp"
            class="collapse"
            aria-labelledby="headingUtilities"
            data-parent="#accordionSidebar"
          >
            <div class="bg-white py-2 collapse-inner rounded">
              <h6 class="collapse-header">Asignación:</h6>
              <router-link class="collapse-item" to="/admin/ads">Imagen publicidad</router-link>
            </div>
          </div>
        </li>

    
        <!-- Nav Item - Utilities Collapse Menu -->
        <li class="nav-item">
          <a
            class="nav-link collapsed"
            href="#"
            data-toggle="collapse"
            data-target="#habeas"
            aria-expanded="true"
            aria-controls="habeas"
          >
            <i class="fas fa-fw fa-wrench"></i>
            <span>Configuración</span>
          </a>
          <div
            id="habeas"
            class="collapse"
            aria-labelledby="headingUtilities"
            data-parent="#accordionSidebar"
          >
            <div class="bg-white py-2 collapse-inner rounded">
              <h6 class="collapse-header">Asignación:</h6>
              <router-link class="collapse-item" :to="{name: 'habeas'}">Opciones</router-link>
            </div>
          </div>
        </li>

        <!-- Nav Item - Utilities Collapse Menu -->
        <li class="nav-item">
          <a
            class="nav-link collapsed"
            href="#"
            data-toggle="collapse"
            data-target="#formats"
            aria-expanded="true"
            aria-controls="formats"
          >
            <i class="fas fa-fw fa-wrench"></i>
            <span>Plantillas</span>
          </a>
          <div
            id="formats"
            class="collapse"
            aria-labelledby="headingUtilities"
            data-parent="#accordionSidebar"
          >
            <div class="bg-white py-2 collapse-inner rounded">
              <h6 class="collapse-header">Plantillas:</h6>
              <router-link class="collapse-item" :to="{name: 'admin-fields'}">Campos</router-link>
              <router-link class="collapse-item" :to="{name: 'admin-formats'}">Plantillas</router-link>
            </div>
          </div>
        </li>

        <li class="nav-item">
          <a
            class="nav-link collapsed"
            href="#"
            data-toggle="collapse"
            data-target="#news"
            aria-expanded="true"
            aria-controls="news"
          >
            <i class="fas fa-fw fa-trash"></i>
            <span>Noticias</span>
          </a>
          <div
            id="news"
            class="collapse"
            aria-labelledby="headingUtilities"
            data-parent="#accordionSidebar"
          >
            <div class="bg-white py-2 collapse-inner rounded">
              <h6 class="collapse-header">Noticias:</h6>
              <router-link class="collapse-item" :to="{name: 'admin-news'}">Publicar noticia</router-link>
            </div>
          </div>
        </li>

        <li class="nav-item">
          <a
            class="nav-link collapsed"
            href="#"
            data-toggle="collapse"
            data-target="#petitions"
            aria-expanded="true"
            aria-controls="petitions"
          >
            <i class="fas fa-fw fa-trash"></i>
            <span>Darse de alta</span>
          </a>
          <div
            id="petitions"
            class="collapse"
            aria-labelledby="headingUtilities"
            data-parent="#accordionSidebar"
          >
            <div class="bg-white py-2 collapse-inner rounded">
              <h6 class="collapse-header">Asignación:</h6>
              <router-link class="collapse-item" :to="{name: 'admin-petitions'}">Darse de alta</router-link>
            </div>
          </div>
        </li>
    
        <!-- Divider -->
        <hr class="sidebar-divider">
  
      </ul>
  </div>
</template>
<script>
export default {
    name: 'admin-sidebar',
}
</script>
<style lang="scss">
    .bg-gradient {
        background-image: linear-gradient(#2352df 80%,rgba(0, 0, 255, 0) 96%) !important;
    }
</style>


